module.exports = __webpack_public_path__ + "media/images/broken_glass.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/broken_glass.png
// module id = 5
// module chunks = 0